export const leadMediaFragment = `
fragment leadMedia on ItemLeadMedia {
  __typename

  ...on ContentItem {
    sourceId
    description
    title
    type
    url
    publishedAt
    updatedAt
    mediaId
    media {
        duration
        hasCaptions
        streamType
    }
    image {
      aspects {
        ratio16x9 {
          url
        }
      }
    }
    showName
    categories {
      id
      name
      type
      slug
    }
    photoGallery { 
      aspectRatio
    }
  }

  ...on Image {
    sourceId
    url
    title
    description
    altText
    credit
    useOriginalImage
    aspects {
      ratio16x9 {
       url
      }
    }
  }
}`;

export const mediaFragment = `
fragment media on ContentItem {
  sourceId
  description
  image {
    aspects {
      ratio16x9 {
        url
      }
    }
  }
  media {
    duration
    hasCaptions
    streamType
  }
  mediaId
  publishedAt
  updatedAt
  showName
  title
  type
}`;

export const segmentFragment = `
fragment segment on ContentItem {
  sourceId
	flag
	url
	title
}`;

export const trendingItem = `fragment trendingItem on ContentItem {
  sourceId
  title
  flag
  href: url
  trending {
      numViewers
      numViewersSRS
  }
}`;
